<template>
  <v-container class="ResetPassword" fluid>
    <v-row v-if="mode === 'emailSent'" justify="center">
      <v-col cols="11" md="9" lg="7" xl="5">
        <v-card class="ResetPassword-card" flat>
          <v-img :src="require(`@/assets/envelope-checked-${$site}.png`)" class="Card-headImg my-2" width="7rem" />
          <v-card-title class="Card-title">{{ $t('resetPassword.emailSent.title') }}</v-card-title>
          <v-card-subtitle class="Card-subtitle mb-10 pb-10">{{
            $t('resetPassword.emailSent.subtitle')
          }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="mode === 'passwordNew'" justify="center">
      <v-col cols="11" md="9" lg="7" xl="5">
        <v-card class="ResetPassword-card" flat>
          <v-img :src="require(`@/assets/envelope-${$site}.png`)" class="Card-headImg" width="7rem" />
          <v-card-title class="Card-title">{{ $t('resetPassword.passwordNew.title') }}</v-card-title>
          <v-card-subtitle class="Card-subtitle">{{ $t('resetPassword.passwordNew.subtitle') }}</v-card-subtitle>
          <v-container>
            <v-row justify="center">
              <v-col cols="10" md="8" lg="6">
                <PasswordInput v-model="password" @submitable="error = false; submitable = $event" />
              </v-col>
            </v-row>
            <v-alert v-if="error" color="error" data-e2e="resetPasswordSuccessMessage" type="error" text dense>{{
              error
            }}</v-alert>
          </v-container>

          <v-card-actions class="justify-center">
            <v-btn
              class="px-10"
              color="primary"
              type="submit"
              @click="submitNewPassword"
              :disabled="!submitable"
              data-e2e="resetPasswordSubmitNewPassword"
              >{{ $t('resetPassword.passwordNew.saveButtonLabel') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="mode === 'passwordConfirmed'" justify="center">
      <v-col cols="11" md="9" lg="7" xl="5">
        <v-card class="ResetPassword-card" flat>
          <v-img :src="([this.$const.sites['nikon-it'], this.$const.sites.nikon].includes(this.$site)) ? '@/assets/resetpassword-icon-validation-black.png' : '@/assets/resetpassword-icon-validation.png'" class="Card-headImg" width="6.5rem" />
          <v-card-title class="Card-title">{{ $t('resetPassword.passwordConfirmed.title') }}</v-card-title>
          <v-card-subtitle class="Card-subtitle mb-10 pb-10">{{
            $t('resetPassword.passwordConfirmed.subtitle')
          }}</v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn class="px-10" color="primary" @click="goToLogin">{{
              $t('resetPassword.passwordConfirmed.letsgoButtonLabel')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PasswordInput from '@/components/login/UI/PasswordInput'

export default {
  name: 'ResetPassword',
  components: { PasswordInput },
  data() {
    return {
      mode: '',
      password: '',
      error: false,
      submitable: false
    }
  },
  created() {
    // CASE : email sent confirmation
    if (this.$route.params.mode === 'emailSent') {
      this.mode = 'emailSent'
      console.log(this.$site)
      setTimeout(() => this.goToLogin(), 115000)
      return
    }
    // CASE : renewing password
    if (this.getToken()) {
      this.mode = 'passwordNew'
      return
    }
    // ELSE CASE : redirect login
    this.goToLogin()
  },
  methods: {
    async submitNewPassword() {
      if (this.notNumber || this.notSpecialChar || !this.submitable) return
      const url = `https://${window.location.host}/auth/confirm-reset-password`
      const token = this.getToken()
      const request = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token,
          password: this.password
        })
      })
      const response = await request.json()
      if (!response.status) {
        switch (response.key) {
          case 'auth.tokenExpired':
            this.error = this.$t('resetPassword.passwordNew.tokenExpired')
            break
          default:
            this.error = this.$t('resetPassword.passwordNew.errorMessage')
            break
        }
      } else {
        this.mode = 'passwordConfirmed'
      }
    },
    goToLogin() {
      this.$router.push({ name: 'Login' })
    },
    getToken() {
      const params = new URL(document.location).searchParams
      return params.get('token')
    }
  }
}
</script>

<style scoped lang="scss">
.ResetPassword {
  width: 100%;
  height: 100%;
  background-color: var(--v-secondary-lighten2);
  padding-top: 5rem;
}

.ResetPassword-card {
  background-color: #fff;
  margin: 1rem 0;
  padding: 4.5rem 0 1rem 0;
  position: relative;
  text-align: center;
  color: var(--v-secondary-base) !important;
  .v-card__title {
    color: var(--v-secondary-base) !important;
  }
}

.Card-headImg {
  width: 7rem;
  position: absolute;
  right: calc(50% - 3.5rem);
  top: -2rem;
  z-index: 100;
}

.Card-title,
.Card-subtitle {
  display: block;
  text-align: center;
  color: var(--v-secondary-base) !important;
  word-break: break-word;
}

.Card-title {
  font-size: 1.7rem;
}

.Card-subtitle {
  font-size: 1rem;
  margin: 5px 0;
}
</style>
